export default {
    join(...args: string[]) {
        return args.join('/')
    }
}